import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import buildClickEvent from '@/utils/functions/buildClickEvent/buildClickEvent';

import type { TutorielVideo } from '@/types/videoTutorials';

const trackTutorialPlay = (partnerName: string, tutorial: TutorielVideo, trackingContext?: string) => {
  void void TRACKING_INSTANCE.triggerEvent(
    'clic',
    undefined,
    buildClickEvent(
      {
        event_nom: 'lecture tutoriel',
        event_detail_1: 'video',
        event_detail_2: `${partnerName.toLowerCase()} - ${tutorial.operation}`,
      },
      trackingContext
    )
  );
};

export default trackTutorialPlay;
